export default __webpack_public_path__ + "static/media/firstimgd.b66300a7.png";